import { useContext } from 'react';

import { AnalyticsContext } from './AnalyticsContext';
import { type Analytics } from './types';

const useAnalytics = (): Analytics => useContext(AnalyticsContext).analytics;

export default useAnalytics;
